import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { ApiAuthOnlyHttpClient } from 'app/http/clients/api-auth-only';
import { Observable } from 'rxjs';
import { Assignment } from './assignment.model';
import { UnattemptedLead } from './unattempted-lead.model';

interface AssignmentResponse {
  data: Assignment;
}

interface NextAssignmentResponse {
  claimRestrictions: ClaimRestrictions;
  flagHighPriority: boolean;
  nextAssignmentExists: boolean;
}

export interface ClaimRestrictions {
  isIpAddressWhitelisted: boolean;
  unattemptedLeads: UnattemptedLead[];
};

@Injectable({
  providedIn: 'root'
})
export class ClaimLeadService {

  constructor(
    private http: ApiHttpClient,
    private authOnlyHttp: ApiAuthOnlyHttpClient
  ) { }

  // we use auth only http client here to bypass the response interceptor that strips the error response
  claimAssignment(): Observable<AssignmentResponse> {
    return this.authOnlyHttp.get<AssignmentResponse>('/assignment-claim');
  }

  getClaimRestrictions(): Observable<ClaimRestrictions> {
    return this.http.get<ClaimRestrictions>('/assignment-claim-restrictions');
  }
}
